/* Venisons Heritage 2026 — Theme JS */

(function() {
  'use strict';

  /* ========= HEADER SCROLL ========= */
  const header = document.querySelector('.site-header');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', function() {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 50);
      last = y;
    }, { passive: true });
  }

  /* ========= MOBILE MENU ========= */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu-close button');

  function openMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.add('active'); document.body.style.overflow = 'hidden'; }
  }
  function closeMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.remove('active'); document.body.style.overflow = ''; }
  }
  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu) mobileMenu.addEventListener('click', function(e) {
    if (e.target === mobileMenu) closeMobileMenu();
  });

  /* ========= MOBILE NAV ACCORDION ========= */
  document.querySelectorAll('.m-group-head').forEach(function(head) {
    head.addEventListener('click', function() {
      const group = head.closest('.m-group');
      if (!group) return;
      const open = group.classList.toggle('open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ========= CART DRAWER ========= */
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartOpen = document.querySelectorAll('[data-cart-open]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartDrawer) { cartDrawer.classList.add('active'); }
    if (cartOverlay) { cartOverlay.classList.add('active'); }
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('active'); }
    if (cartOverlay) { cartOverlay.classList.remove('active'); }
    document.body.style.overflow = '';
  }

  cartOpen.forEach(function(el) { el.addEventListener('click', function(e) { e.preventDefault(); openCart(); }); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function(el) { el.textContent = count; });
  }

  function refreshCart() {
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart) {
      updateCartCount(cart.item_count);
      var items = document.querySelector('.cart-drawer-items');
      var footer = document.querySelector('.cart-drawer-footer');
      if (!items) return;
      if (cart.item_count === 0) {
        items.innerHTML = '<div class="cart-drawer-empty"><p>Your bag is empty</p><a href="/collections/all" class="btn btn-dark">Continue Shopping</a></div>';
        if (footer) footer.style.display = 'none';
        return;
      }
      if (footer) footer.style.display = '';
      var html = '';
      cart.items.forEach(function(item) {
        var img = item.image ? item.image.replace(/(\.\w+)$/, '_160x200$1') : '';
        html += '<div class="cart-drawer-item">';
        html += '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '">';
        html += '<div class="cart-drawer-item-info">';
        html += '<div class="cart-drawer-item-title">' + escapeHtml(item.product_title) + '</div>';
        if (item.variant_title) html += '<div class="cart-drawer-item-variant">' + escapeHtml(item.variant_title) + '</div>';
        html += '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>';
        html += '<div class="cart-qty" data-line-key="' + item.key + '">';
        html += '<button type="button" data-cart-qty="minus" aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>';
        html += '<span class="cart-qty-val">' + item.quantity + '</span>';
        html += '<button type="button" data-cart-qty="plus" aria-label="Increase quantity">&plus;</button>';
        html += '</div>';
        html += '<p class="cart-qty-note" data-cart-note hidden>Looking for a larger quantity? <a href="/pages/contact">Contact us</a> and we’ll source it for you.</p>';
        html += '<button class="cart-drawer-item-remove" data-line-key="' + item.key + '">Remove</button>';
        html += '</div></div>';
      });
      items.innerHTML = html;

      var subtotal = document.querySelector('.cart-drawer-subtotal .subtotal-amount');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      items.querySelectorAll('.cart-qty').forEach(function(wrap) {
        var key = wrap.getAttribute('data-line-key');
        var note = wrap.parentNode.querySelector('[data-cart-note]');
        var valEl = wrap.querySelector('.cart-qty-val');
        var minusBtn = wrap.querySelector('[data-cart-qty="minus"]');
        var plusBtn = wrap.querySelector('[data-cart-qty="plus"]');
        if (minusBtn) minusBtn.addEventListener('click', function() {
          var cur = parseInt(valEl.textContent, 10) || 1;
          if (cur <= 1) return;
          minusBtn.disabled = true;
          cartChange(key, cur - 1).then(function() { refreshCart(); });
        });
        if (plusBtn) plusBtn.addEventListener('click', function() {
          var cur = parseInt(valEl.textContent, 10) || 1;
          plusBtn.disabled = true;
          cartChange(key, cur + 1).then(function(res) {
            if (!res.ok || (res.data && res.data.status)) {
              // Requested more than we hold — surface the contact note, keep current qty
              if (note) note.hidden = false;
              plusBtn.disabled = false;
              return;
            }
            refreshCart();
          });
        });
      });

      items.querySelectorAll('.cart-drawer-item-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = this.getAttribute('data-line-key');
          cartChange(key, 0).then(function() { refreshCart(); });
        });
      });
    });
  }

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Update a cart line quantity. Resolves { ok, data } so callers can
  // detect a stock rejection (Shopify returns 422 when you ask for more
  // than is in stock under a "deny" inventory policy).
  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, data: data }; });
    });
  }

  /* ========= AJAX ADD TO CART ========= */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, data: data }; });
    }).then(function(res) {
      if (!res.ok) {
        // Stock limit reached on add — surface the contact note, restore button
        var note = form.querySelector('[data-qty-note]');
        if (note) note.hidden = false;
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        return;
      }
      if (btn) { btn.textContent = 'Added!'; }
      openCart();
      setTimeout(function() { if (btn) { btn.textContent = origText; btn.disabled = false; } }, 1500);
    }).catch(function() {
      if (btn) { btn.textContent = origText; btn.disabled = false; }
    });
  });

  /* ========= PRODUCT GALLERY ========= */
  var mainImg = document.querySelector('.product-gallery-main img');
  var thumbs = document.querySelectorAll('.product-gallery-thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = this.getAttribute('data-full');
      if (mainImg && src) { mainImg.src = src; }
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ========= VARIANT SELECTOR ========= */
  var variantPills = document.querySelectorAll('.variant-pill');
  var variantInput = document.getElementById('variant-id');
  var variantData = window.__variants || [];

  variantPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      var group = this.getAttribute('data-option-group');
      document.querySelectorAll('.variant-pill[data-option-group="' + group + '"]').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      updateSelectedVariant();
    });
  });

  function getSelectedOptions() {
    var opts = {};
    document.querySelectorAll('.variant-pill.active').forEach(function(p) {
      opts[p.getAttribute('data-option-group')] = p.getAttribute('data-value');
    });
    return opts;
  }

  function updateSelectedVariant() {
    var opts = getSelectedOptions();
    var keys = Object.keys(opts);
    for (var i = 0; i < variantData.length; i++) {
      var v = variantData[i];
      var match = true;
      for (var k = 0; k < keys.length; k++) {
        var idx = parseInt(keys[k]);
        if (v['option' + (idx + 1)] !== opts[keys[k]]) { match = false; break; }
      }
      if (match) {
        if (variantInput) variantInput.value = v.id;
        var priceEl = document.querySelector('.product-info-price');
        if (priceEl) {
          var html = '';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html = '<span class="compare">' + formatMoney(v.compare_at_price) + '</span> <span class="sale">' + formatMoney(v.price) + '</span>';
          } else {
            html = formatMoney(v.price);
          }
          priceEl.innerHTML = html;
        }
        var addBtn = document.querySelector('.add-to-bag-btn');
        if (addBtn) {
          if (v.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Bag';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          }
        }
        // Update URL
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
        // Re-apply the stock cap for the newly selected variant
        enforceProductQty();
        break;
      }
    }
  }

  /* ========= QUANTITY SELECTOR — PRODUCT PAGE (stock aware) ========= */
  // window.__variantStock is emitted per-product: { <variantId>: { tracked, policy, qty } }
  var stockMap = window.__variantStock || {};

  function activeStockMax() {
    // Returns the max purchasable qty for the selected variant, or null = unlimited.
    if (!variantInput) return null;
    var s = stockMap[variantInput.value];
    if (!s || !s.tracked || s.policy === 'continue') return null;
    return s.qty > 0 ? s.qty : 0;
  }

  var productQtySel = document.querySelector('.quantity-selector[data-product-qty]');
  var productQtyInput = productQtySel ? productQtySel.querySelector('input') : null;
  var productQtyMinus = productQtySel ? productQtySel.querySelector('[data-qty="minus"]') : null;
  var productQtyPlus = productQtySel ? productQtySel.querySelector('[data-qty="plus"]') : null;
  var productQtyNote = document.querySelector('[data-qty-note]');

  function enforceProductQty() {
    if (!productQtyInput) return;
    var max = activeStockMax();
    var val = parseInt(productQtyInput.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (max !== null) {
      productQtyInput.max = max > 0 ? max : 1;
      if (val > max) val = max > 0 ? max : 1;
    } else {
      productQtyInput.removeAttribute('max');
    }
    productQtyInput.value = val;
    var atMax = (max !== null && max > 0 && val >= max);
    if (productQtyNote) productQtyNote.hidden = !atMax;
    if (productQtyPlus) productQtyPlus.disabled = atMax;
  }

  if (productQtyMinus) productQtyMinus.addEventListener('click', function() {
    productQtyInput.value = (parseInt(productQtyInput.value, 10) || 1) - 1;
    enforceProductQty();
  });
  if (productQtyPlus) productQtyPlus.addEventListener('click', function() {
    productQtyInput.value = (parseInt(productQtyInput.value, 10) || 1) + 1;
    enforceProductQty();
  });
  if (productQtyInput) {
    productQtyInput.addEventListener('input', enforceProductQty);
    productQtyInput.addEventListener('change', enforceProductQty);
  }
  enforceProductQty();

  /* ========= QUANTITY SELECTOR — GENERIC (full cart page lines) ========= */
  document.querySelectorAll('.quantity-selector:not([data-product-qty])').forEach(function(sel) {
    var input = sel.querySelector('input');
    if (!input) return;
    var minus = sel.querySelector('[data-qty="minus"]');
    var plus = sel.querySelector('[data-qty="plus"]');
    var note = sel.parentNode ? sel.parentNode.querySelector('[data-qty-note]') : null;
    var max = sel.dataset.stockMax ? parseInt(sel.dataset.stockMax, 10) : null;
    var min = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 1;
    if (isNaN(min)) min = 1;

    function update() {
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = min;
      if (val < min) val = min;
      if (max !== null && val > max) val = max;
      input.value = val;
      var atMax = (max !== null && val >= max);
      if (note) note.hidden = !atMax;
      if (plus) plus.disabled = atMax;
    }
    if (minus) minus.addEventListener('click', function() { input.value = (parseInt(input.value, 10) || min) - 1; update(); });
    if (plus) plus.addEventListener('click', function() { input.value = (parseInt(input.value, 10) || min) + 1; update(); });
    input.addEventListener('input', update);
    input.addEventListener('change', update);
    update();
  });

  /* ========= ACCORDION ========= */
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var panel = this.nextElementSibling;
      var isOpen = this.classList.contains('active');
      this.classList.toggle('active');
      if (isOpen) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ========= COLLECTION SORT ========= */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url;
    });
  }

  /* ========= LAZY LOAD ========= */
  if ('IntersectionObserver' in window) {
    var lazyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
          lazyObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('img[data-src]').forEach(function(img) { lazyObserver.observe(img); });
  }

  /* ========= INIT CART COUNT ========= */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updateCartCount(c.item_count);});

})();
